import React, { useState, useEffect } from "react";
import "../Dashboard.scss";
import { Row, Col, Progress } from "reactstrap";
import "./HCDashboard.scss";
import gql from "graphql-tag";
import { useQuery, useMutation } from "react-apollo";
import * as moment from "moment";

const QUERY = gql`
  query {
    getDataDashboardLeaves {
      request_leave_last_month
      allowance
      current_leave_usage
      allowance_last_year
      last_year_leave_usage
      employees
      employeesLastYear
    }
  }
`;

const HCLeaves = (props) => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    fetchPolicy: "cache-and-network",
  });
  const [perQuota, setPerQuota] = useState(0);
  const [perYear, setPerYear] = useState(0);

  useEffect(() => {
    if (data) {
      if (data.getDataDashboardLeaves) {
        let percentQuota =
          (data.getDataDashboardLeaves.current_leave_usage /
            data.getDataDashboardLeaves.allowance) *
          100;
        setPerQuota(percentQuota.toFixed(2));

        let percentYear =
          (data.getDataDashboardLeaves.last_year_leave_usage /
            data.getDataDashboardLeaves.allowance_last_year) *
          100;
        setPerYear(percentYear.toFixed(2));
      } else {
        setPerQuota(0);
        setPerYear(0);
      }
    }
  }, [data]);

  return (
    <div className="section p5">
      <div className="sectioncontent">
        <h5 className="blocktext">Leaves</h5>
        <Row className="cardHC">
          <Col>
            <div className="total">
              <div className="nth1">
                <i className="fa fa-history"></i>
              </div>
              <div className="nth2">
                <div>
                  <span>Allowance Total {moment().format("YYYY")}</span>
                </div>
                <div>
                  <h4>
                    {data ? data.getDataDashboardLeaves.allowance : ""} (
                    {data ? data.getDataDashboardLeaves.employees : ""}{" "}
                    Employees)
                  </h4>
                </div>
              </div>
              <div className="nth3"></div>
            </div>
          </Col>
          <Col>
            <div className="this-year">
              <div className="nth1">
                <i className="fa fa-history"></i>
              </div>
              <div className="nth2">
                <div className="nth1-year">
                  <div>
                    <span>Current Usage</span>
                  </div>
                  <div>
                    <h5>
                      {data
                        ? data.getDataDashboardLeaves.current_leave_usage
                        : ""}{" "}
                      / {data ? data.getDataDashboardLeaves.allowance : ""}
                    </h5>
                  </div>
                </div>
                <div className="nth2">
                  <Progress value={perQuota} color="secondary">
                    <span className="text-dark">
                      <span className="text-dark">{perQuota}%</span>
                      &nbsp; Usage
                    </span>
                  </Progress>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="this-year">
              <div className="nth1">
                <i className="fa fa-history"></i>
              </div>
              <div className="nth2">
                <div className="nth1-year">
                  {" "}
                  <div>
                    <span>Request Last Month</span>
                  </div>
                  <div>
                    <h4 className="text-white">
                      Total :{" "}
                      {data
                        ? data.getDataDashboardLeaves.request_leave_last_month
                        : ""}
                    </h4>
                  </div>{" "}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <br></br>
        <Row className="cardHC">
          <Col>
            <div className="total">
              <div className="nth1">
                <i className="fa fa-history"></i>
              </div>
              <div className="nth2">
                <div>
                  <span>Allowance Last Year {moment().format("YYYY") - 1}</span>
                </div>
                <div>
                  <h4>
                    {data
                      ? data.getDataDashboardLeaves.allowance_last_year
                      : ""}{" "}
                    ({data ? data.getDataDashboardLeaves.employeesLastYear : ""}{" "}
                    Employees)
                  </h4>
                </div>
              </div>
              <div className="nth3"></div>
            </div>
          </Col>
          <Col>
            <div className="this-year">
              <div className="nth1">
                <i className="fa fa-history"></i>
              </div>
              <div className="nth2">
                <div className="nth1-year">
                  <div>
                    <span>Last Year Usage</span>
                  </div>
                  <div>
                    <h5>
                      {data
                        ? data.getDataDashboardLeaves.last_year_leave_usage
                        : ""}{" "}
                      /{" "}
                      {data
                        ? data.getDataDashboardLeaves.allowance_last_year
                        : ""}
                    </h5>
                  </div>
                </div>
                <div className="nth2">
                  <Progress value={perYear} color="secondary">
                    <span className="text-dark">
                      <span className="text-dark">{perYear}%</span>
                      &nbsp; Usage
                    </span>
                  </Progress>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="this-year">
              <div className="nth1">
                <i className="fa fa-arrow-right"></i>
              </div>
              <div className="nth2">
                <div className="nth1-year">
                  <div>
                    <h4
                      className="text-white"
                      style={{ textDecoration: "none" }}
                    >
                      <a
                        href="#/HC/leave_list"
                        className="text-white"
                        style={{ textDecoration: "none" }}
                      >
                        Leave List{" "}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {/* <Row>
          <Col md="12">
            <Row>
              <Col md="4">
                <h5>
                  Allowance (Total) :{" "}
                  <span className="badge badge-success">
                    {data ? data.getDataDashboardLeaves.allowance : ""} (from{" "}
                    {data ? data.getDataDashboardLeaves.employees : ""}{" "}
                    employees)
                  </span>
                </h5>
              </Col>
              <Col md="3">
                <h5>
                  Request Last Month (Total) :{" "}
                  <span className="badge badge-primary">
                    {data
                      ? data.getDataDashboardLeaves.request_leave_last_month
                      : ""}
                  </span>
                </h5>
              </Col>
            </Row>
            <Row>
              <Col md="2">
                <h6 style={{ marginTop: 8 }}>Current Usage (Total)</h6>
                <h5 className="text-info" className="leaveAllowance">
                  {data ? data.getDataDashboardLeaves.current_leave_usage : ""}{" "}
                  / {data ? data.getDataDashboardLeaves.allowance : ""}
                </h5>
              </Col>
              <Col md="10">
                <h6>Leave Quota (All Employee)</h6>
                <Progress value={perQuota} color="danger">
                  {perQuota} %
                </Progress>
              </Col>
            </Row>
            <br />
            <h5>
              Allowance Last Year (Total) :{" "}
              <span className="badge badge-success">
                {data ? data.getDataDashboardLeaves.allowance_last_year : ""}{" "}
                (from{" "}
                {data ? data.getDataDashboardLeaves.employeesLastYear : ""}{" "}
                employees)
              </span>
            </h5>
            <Row>
              <Col md="2">
                <h6 style={{ marginTop: 8 }}>Last Year Usage (Total)</h6>
                <h5 className="text-info" className="leaveAllowance">
                  {data
                    ? data.getDataDashboardLeaves.last_year_leave_usage
                    : ""}{" "}
                  /{" "}
                  {data ? data.getDataDashboardLeaves.allowance_last_year : ""}
                </h5>
              </Col>
              <Col md="10">
                <h6 style={{ marginTop: 8 }}>Last Year Usage</h6>
                <Progress value={perYear} color="info">
                  {perYear} %
                </Progress>
              </Col>
            </Row>
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

export default HCLeaves;
